import { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Divider,
  Badge,
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
// components
import Avatar from '../../components/Avatar';
import SvgIconStyle from '../../components/SvgIconStyle';
import DIOText from '../../components/DIOText';
// hooks
import useResponsive from '../../hooks/useResponsive';

const PrimaryText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.text.primary,
  };
});

// ----------------------------------------------------------------------

export default function ProfileCard({ profile }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Card
      sx={{
        my: 5,
        minWidth: '320px',
        width: '320px',
        height: '200px',
        boxShadow: (theme) => theme.customShadows.card,
        border: (theme) => `solid 1px ${alpha(theme.palette.grey[500], 0.06)}`,
      }}
    >
      <CardContent sx={{ py: 2, '&:last-child': { py: 2 } }}>
        <Stack
          direction="column"
          divider={<Divider orientation="horizontal" flexItem />}
          spacing={1.5}
          alignItems={"center"}
        >
          <Stack
            direction={"row-reverse"} spacing={3}
            sx={{
              width: 1,
            }}
            justifyContent={"space-between"}
          >
            <Badge
              sx={{
                width: 48,
                height: 48,
              }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              badgeContent={
                <SvgIconStyle src={`/icons/ic_verified.svg`} sx={{ color: "info.main", mr: 2, mb: 3, width: 20, height: 20 }} />
              }
            >
              <Avatar
                src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${profile?.crew_hash || '5'}.png`}
                alt={profile?.name}
                color={'default'}
                sx={{
                  margin: 'auto',
                  borderWidth: 2,
                  borderStyle: 'solid',
                  borderColor: 'common.white',
                  width: 48,
                  height: 48,
                }}
              />
            </Badge>
            <Stack spacing={1}>
              <Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="h6">
                    {profile?.role || ''}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {profile?.position}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center" divider={<Divider orientation={"vertical"} flexItem />}>
                  <Typography variant="caption" color="text.secondary">
                    <PrimaryText>{profile?.name}</PrimaryText> 크루
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {profile?.years}년차
                  </Typography>
                  {profile?.has_others && (
                    <Typography variant="caption" color="text.secondary">
                      다른 스택도 가능
                    </Typography>
                  )}
                </Stack>
              </Stack>
              <Stack spacing={0.5}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <Typography variant="h6" color={"secondary.main"}>
                    {profile?.salary}만원
                  </Typography>
                  <Typography variant="subtitle2" color="secondary.main">
                    / 4주
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <SvgIconStyle src={`/icons/ic_clock.svg`} sx={{ color: "text.disabled", width: 16, height: 16 }} />
                  <Typography variant={"caption"} color="text.secondary">
                    <b>주 {profile?.hours}시간</b> 근무
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          {(profile?.career_name || profile?.contract_count > 0) && (
          <Stack sx={{ width: 1 }} spacing={smUp ? 1 : 0.5}>
            {profile?.career_name && (
            <Stack direction="row" spacing={.5} alignItems="center">
              <SvgIconStyle src={`/icons/ic-job.svg`} sx={{ color: "text.disabled", width: 16, height: 16 }} />
              <Typography variant={"caption"} color="text.secondary">
                {profile?.career_name}
              </Typography>
            </Stack>
            )}
            {profile?.contract_count > 0 && (
            <Stack direction="row" spacing={.5} alignItems="center">
              <SvgIconStyle src={`/icons/icon-lightning-mono.svg`} sx={{ color: "text.disabled", width: 16, height: 16 }} />
              <Typography variant={"caption"} color="text.secondary">
                <DIOText />에서 계약 {profile?.contract_count}번째!
              </Typography>
            </Stack>
            )}
          </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
